import { Media } from '@eiq/files/models';

export interface LoopAllocationSettings {
  quantity?: number;
  completionTarget?: number;
}

export interface LoopSourceReference {
  sourceId: string;
  /** Permanent one-based ordinal, never a presentation/array position. */
  sourceIndex: number;
  sourceName: string;
}

export interface SurveyInstanceIdentity {
  templateQuestionId: string;
  templatePageId: string;
  loopId: string;
  sourceId: string;
  /** Permanent one-based ordinal, never a presentation/array position. */
  sourceIndex: number;
  questionId: string;
  pageId: string;
}

/** Index belongs to this survey's source list, not the reusable media asset. */
export interface LoopSourceMedia extends Media {
  sourceIndex: number;
}
